/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon24Regular = forwardRef('ArrowDCornerLeftDownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.125 7A3.875 3.875 0 0 1 12 3.125h9a.875.875 0 0 1 0 1.75h-9A2.125 2.125 0 0 0 9.875 7v11.887l5.256-5.256a.875.875 0 1 1 1.238 1.238l-5.504 5.503a2.637 2.637 0 0 1-3.73 0L1.631 14.87A.875.875 0 1 1 2.87 13.63l5.256 5.257V7Z" })));
});
